declare global {
  interface Window {
    fbq: any
    _fbq: any
    __fbPixelInitialized: boolean
    __fbPixelFired: boolean
  }
}

const PIXEL_ID = '926494449790428'

function firePixelEvents(): void {
  // Second guard so init+PageView only fire once even if both stub and onload trigger
  if (window.__fbPixelFired) return
  window.__fbPixelFired = true
  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
}

export function initMetaPixel(): void {
  // Guard: prevent duplicate initialization (React StrictMode / HMR safe)
  if (window.__fbPixelInitialized) return
  window.__fbPixelInitialized = true

  // Set up the fbq stub exactly as Meta specifies
  if (!window.fbq) {
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!window._fbq) window._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    window.fbq = n
  }

  // Inject fbevents.js
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'

  // Fire on script load (real library active) — guarded against duplicates
  script.onload = () => firePixelEvents()

  document.head.appendChild(script)

  // Also fire via stub queue immediately — guarded against duplicates
  firePixelEvents()
}

export function trackInitiateCheckout(): void {
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'InitiateCheckout')
  }
}
